import { DESKTOP_MEDIA_QUERY } from "@/common/constants";
import {
  getDataSize,
  type DataSizeUnit as DataSizeUnitType,
} from "@/common/dataFormatter";
import { useMediaQuery } from "@/utils/hooks";
import { FormattedNumber } from "react-intl";

export type DataSizeUnit = DataSizeUnitType;

interface FormattedDataSizeProps {
  bytes: number | bigint;
}

export const FormattedDataSize = ({
  bytes,
}: Readonly<FormattedDataSizeProps>) => {
  const { value, unit } = getDataSize(BigInt(bytes));
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);

  return (
    <FormattedNumber
      value={value}
      style="unit"
      unit={unit}
      unitDisplay="short"
      maximumFractionDigits={isDesktop ? 2 : 1}
    />
  );
};
